import { Tab, Tabs } from 'react-bootstrap';
import style from './index.module.css';
import Damage from './Pages/Damage/Damage';
import useFactionData from '../hooks/useFactionData/useFactionData';
import { LibraryContext } from '../Contexts/LibraryContext/LibraryContext';
import FaceOff from './Pages/FaceOff/FaceOff';
import { FactionContext } from '../Contexts/FactionContext/FactionContext';
import { useCallback, useState } from 'react';
import { factionNames } from '../hooks/useFactionData/useFactionData.constant';

function ProbabilityHome() {
  //data-bs-theme="dark"
  
  const { data } = useFactionData();

  const [faction, setFaction] = useState(localStorage.getItem('faction') ?? factionNames[0]);

  const updateFaction = useCallback((f: string) => {
    setFaction(f);
    localStorage.setItem('faction', f);
  }, []);

  return (
    <LibraryContext.Provider value={data}>
      <FactionContext.Provider value={{ faction, updateFaction }}>
        <div className={`${style.probabiltyContainer} bg-body-tertiary`} >
          <Tabs
            defaultActiveKey="damage"
            className="mb-3"
          >
            <Tab eventKey="damage" title="Damage">
              <Damage />
            </Tab>
            <Tab eventKey="faceoff" title="Face Off">
              <FaceOff />
            </Tab>
          </Tabs>
        </div>
      </FactionContext.Provider>
    </LibraryContext.Provider>
  );
}

export default ProbabilityHome;